// CrcPublishers.js
import React from 'react';
import Book1 from '../../../assets/Images/book1.jpeg';
import { 
  FaAmazon, 
  FaGoogle, 
  FaBook, 
  FaShippingFast, 
  FaAward, 
  FaUsers,
  FaRegNewspaper,
  FaBalanceScale,
  FaGraduationCap,
  FaShoppingCart
} from 'react-icons/fa';

const CrcPublishers = () => {
  const books = [
    {
      id: 1,
      title: "Caveat Emptor to Consumer Power",
      subtitle: "Demystifying Consumer Protection Act 2019 with Real World Solutions",
      description: "A comprehensive guide that transitions readers from the ancient principle of 'Buyer Beware' to modern consumer empowerment under the Consumer Protection Act 2019. This authoritative publication provides practical insights and legal frameworks for consumer protection.",
      image: Book1,
      isbn: "ISBN: 978-93-6426-438-9",
      pages: "284 Pages",
      year: "2023",
      platforms: [
        {
          name: "Amazon",
          url: "https://www.amazon.in/Caveat-Emptor-Consumer-Power-Demystifying/dp/936426438X",
          icon: <FaAmazon className="text-xl" />,
          color: "border-orange-500 text-orange-600 hover:bg-orange-50"
        },
        {
          name: "Flipkart",
          url: "https://www.flipkart.com/caveat-emptor-consumer-power-demystifying-protection-act-2019-real-world-solutions/p/itm9ed078bce4272?pid=9789364264389",
          icon: <FaShippingFast className="text-xl" />,
          color: "border-blue-500 text-blue-600 hover:bg-blue-50"
        },
        {
          name: "Google Play",
          url: "https://play.google.com/store/books/details?id=vl-DEQAAQBAJ",
          icon: <FaGoogle className="text-xl" />,
          color: "border-green-500 text-green-600 hover:bg-green-50"
        },
        {
          name: "BooksCamel",
          url: "https://bookscamel.in/app/views/shop-details.php?id=612",
          icon: <FaBook className="text-xl" />,
          color: "border-purple-500 text-purple-600 hover:bg-purple-50"
        }
      ]
    },
  ];

  const stats = [
    { icon: <FaBook />, number: "10,000+", label: "Copies Sold" },
    { icon: <FaUsers />, number: "50+", label: "Cities Covered" },
    { icon: <FaAward />, number: "4.8/5", label: "Reader Rating" },
    { icon: <FaRegNewspaper />, number: "100+", label: "Media Features" }
  ];

  const features = [
    {
      icon: <FaBalanceScale className="text-2xl" />,
      title: "Legal Expertise",
      description: "Authored by leading consumer rights experts and legal professionals"
    },
    {
      icon: <FaGraduationCap className="text-2xl" />,
      title: "Educational Value",
      description: "Comprehensive resource for students, professionals, and general public"
    },
    {
      icon: <FaAward className="text-2xl" />,
      title: "Award-Winning",
      description: "Recognized for excellence in consumer education and awareness"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Official Header with Logo */}
      <header className="bg-white border-b-4 border-blue-800 shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-blue-800 rounded-lg flex items-center justify-center">
                <FaBalanceScale className="text-white text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">CRC Publications</h1>
                <p className="text-sm text-gray-600">Consumer Rights Council</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-600">Official Publication Division</p>
              <p className="text-xs text-gray-500">Est. 2010</p>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-blue-700 px-4 py-2 rounded-full mb-6">
              <FaAward className="text-yellow-400" />
              <span className="text-sm font-medium">Official Publications Division</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Authoritative Consumer Rights Publications
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed mb-8">
              The Consumer Rights Council (CRC) proudly publishes research-based, authoritative books 
              that promote consumer education, legal literacy, and public empowerment. Each publication 
              undergoes rigorous review and reflects our commitment to excellence.
            </p>
            
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-white py-12 border-b">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-blue-600 mb-2 flex justify-center">
                  {stat.icon}
                </div>
                <div className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Publications */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Official Publications
            </h2>
            <div className="w-24 h-1 bg-blue-800 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Carefully curated and professionally published works that represent the highest standards 
              of consumer rights education and legal guidance.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {books.map(book => (
              <div key={book.id} className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                <div className="md:flex">
                  {/* Book Cover */}
                  <div className="md:w-2/5 bg-gradient-to-br from-blue-50 to-gray-50 p-8 flex items-center justify-center">
                    <div className="relative">
                      <img 
                        src={book.image} 
                        alt={book.title}
                        className="w-48 h-64 object-cover rounded-lg shadow-2xl mx-auto border-4 border-white"
                        onError={(e) => {
                          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjI2MCIgdmlld0JveD0iMCAwIDIwMCAyNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjYwIiBmaWxsPSIjRjNGNEY2Ii8+CjxyZWN0IHg9IjQwIiB5PSIyMCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSIyMjAiIGZpbGw9IiNFOEU2RTYiIHN0cm9rZT0iI0NEQ0RDRCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTQwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjN0Y4ODk1IiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiPkNSUCBCb29rPC90ZXh0Pgo8L3N2Zz4K';
                        }}
                      />
                      {/* Official Badge */}
                      <div className="absolute -top-2 -right-2 bg-blue-800 text-white px-3 py-1 rounded-full text-xs font-bold">
                        OFFICIAL
                      </div>
                    </div>
                  </div>
                  
                  {/* Book Details */}
                  <div className="md:w-3/5 p-8">
                    <div className="mb-4">
                      <span className="bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full">
                        Featured Publication
                      </span>
                    </div>
                    
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {book.title}
                    </h3>
                    <p className="text-blue-700 font-medium mb-4 italic">
                      {book.subtitle}
                    </p>
                    
                    <p className="text-gray-600 leading-relaxed mb-6">
                      {book.description}
                    </p>
                    
                    {/* Book Metadata */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <div className="flex items-center text-sm text-gray-600">
                        <FaBook className="mr-2 text-blue-600" />
                        {book.pages}
                      </div>
                      <div className="flex items-center text-sm text-gray-600">
                        <FaRegNewspaper className="mr-2 text-blue-600" />
                        {book.year}
                      </div>
                    </div>
                    <div className="mb-6">
                      <p className="text-sm text-gray-500 font-mono">
                        {book.isbn}
                      </p>
                    </div>
                    
                    {/* Purchase Section */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                        <FaShoppingCart className="mr-2 text-blue-600" />
                        Available on Official Platforms
                      </h4>
                      <div className="grid grid-cols-2 gap-3">
                        {book.platforms.map((platform, index) => (
                          <a
                            key={index}
                            href={platform.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`border-2 ${platform.color} px-4 py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center space-x-2`}
                          >
                            {platform.icon}
                            <span>{platform.name}</span>
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50 border-t border-b">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Why Choose CRC Publications?
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our publications stand out for their quality, accuracy, and commitment to consumer empowerment.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {features.map((feature, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 text-center">
                <div className="text-blue-600 mb-4 flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    
    </div>
  );
};

export default CrcPublishers;